import React from "react"
import SortableTable from "./sortable-table"
import senatorVotes from "../csv/senator-votes"
import Papa from "papaparse"

export default function HowSenatorsVotedTable() {
  const { data: rows } = Papa.parse(senatorVotes.trim(), {
    header: true,
  })

  const columns = [
    {
      field: "District",
    },
    {
      field: "Senator",
    },
    {
      field: "SB79 Vote",
      render(row, field) {
        const value = row[field]
        let className

        if (value === "No") {
          className = "text-green-500"
        } else if (value === "Yes") {
          className = "text-red-500"
        } else if (value === "NVR") {
          className = "text-blue-500"
        }

        return <span className={className}>{value}</span>
      },
    },
    {
      field: "Party",
    },
  ]

  return (
    <>
      <SortableTable
        className="w-full xl:w-3/4 xl:mx-auto"
        rows={rows}
        columns={columns}
        defaultSort="district:asc"
        // caption={() => {
        //   return <></>
        // }}
      />
    </>
  )
}
